import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { Box } from 'src/components/Box';
import { Icon } from 'src/components/Icon';
import { Typography } from 'src/components/Typography';
import {
  Leaderboard,
  LeaderboardDivision,
  LeaderboardResultItem,
} from 'src/models/leaderboard/_types';

import { LeaderboardResultsList } from './LeaderboardResultsList';

interface LeaderboardSummaryProps {
  division: LeaderboardDivision;
  results: LeaderboardResultItem[];
  leaderboard?: Leaderboard | null;
  tvMode?: boolean;
  numeric?: boolean;
  onDivisionClick: (division: LeaderboardDivision) => void;
}

export const LeaderboardSummary = ({
  division,
  results,
  leaderboard,
  tvMode = false,
  numeric = true,
  onDivisionClick,
}: LeaderboardSummaryProps) => {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mx: 2,
          mb: 1,
          cursor: 'pointer',
        }}
        onClick={() => onDivisionClick(division)}
      >
        <Typography variant="body1" sx={{ mr: 1.5 }}>
          {division.label}
        </Typography>
        {!tvMode && <Icon icon={faChevronRight} size="small" />}
      </Box>
      <LeaderboardResultsList
        results={results}
        tvMode={tvMode}
        numeric={numeric}
        leaderboard={leaderboard}
      />
    </Box>
  );
};
